export const SYNTAX_HIGHLIGHTER_DEFAULT_DARK_THEME = 'material-theme-darker';
export const SYNTAX_HIGHLIGHTER_DEFAULT_LIGHT_THEME = 'github-light';
